/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect } from 'react';
import { useCommands, useEditorEvent } from '@remirror/react';

interface ContextAccessorProps {
  markdown: string;
  onBlur?: () => void;
  onFocus?: () => void;
}

export const ContextAccessor = ({
  markdown,
  onBlur,
  onFocus,
}: ContextAccessorProps) => {
  const commands = useCommands();

  onBlur && useEditorEvent('blur', onBlur);
  onFocus && useEditorEvent('focus', onFocus);

  useEffect(() => {
    if (markdown) {
      commands.setContent(markdown);
      commands.focus('start');
    }
  }, [markdown, commands]);

  return null;
};
